export default "__VITE_ASSET__Bb4ykvdx__"